import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.VUE_APP_AUTH_SIGNIN_ENDPOINT,
        changePassword: "B2C_1A_PASSWORDCHANGE"
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${process.env.VUE_APP_AUTH_DOMAIN}/${process.env.VUE_APP_AUTH_GUID}/${process.env.VUE_APP_AUTH_SIGNIN_ENDPOINT.toLowerCase()}`,
            navigateToLoginRequestUrl: true
        },
        passwordChange: {
            authority: `https://${process.env.VUE_APP_AUTH_DOMAIN}/${process.env.VUE_APP_AUTH_GUID}/B2C_1A_PASSWORDCHANGE`
        }
    },
    authorityDomain: process.env.VUE_APP_AUTH_DOMAIN
};

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: process.env.VUE_APP_AUTH_REDIRECT_URI,
        postLogoutRedirectUri: "https://www.microchip.com",
        PasswordChangeUri: b2cPolicies.authorities.passwordChange.authority
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: isIE || isEdge || isFirefox
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

// Scopes you add here will be prompted for consent during login
export const loginRequest = {
    scopes: [
        `https://${process.env.VUE_APP_AUTH_SCOPE}/userpreferenceapi/task.readwrite`,
        "openid",
        "offline_access"
    ]
};

export const forgotPasswordRequest = {
    scopes: ['openid', 'offline_access']
};

export const tokenRequest = {
    scopes: [
        `https://${process.env.VUE_APP_AUTH_SCOPE}/userpreferenceapi/task.readwrite`,
        "offline_access"
    ],  // e.g. ["https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"]
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const myMSALObj = new PublicClientApplication(msalConfig);

// All 3 scopes for reference 
// "https://mchpab2cdev.onmicrosoft.com/microchip-sample-api/samples.all",
// "https://mchpab2cdev.onmicrosoft.com/userpreferenceapi/task.readwrite",
// "https://mchpab2cdev.onmicrosoft.com/usersecuredresourceapi/task.readwrite"

/**
 * Enter here the coordinates of your web API and scopes for access token request
 * The current application coordinates were pre-registered in a B2C tenant.
 */
// export const apiConfig = {
//     scopes: ['https://mchpab2cdev.onmicrosoft.com/microchip-sample-api/samples.all'],
//     uri: 'https://mchpab2cdev.onmicrosoft.com/microchip-sample-api'
// };
